export interface Interpretation {
  id: number;
  text: string;
  language: string;
  philosophy: string;
}

export interface InterpretationCreate {
  text: string;
  language: string;
  philosophy: string;
}

export interface InterpretationUpdate {
  id: number;
  text: string;
  language: string;
  philosophy: string;
}

export const LANGUAGES = {
  SA: 'sa', // Sanskrit
  EN: 'en', // English
  HI: 'hi', // Hindi
  KN: 'kn', // Kannada
  TA: 'ta', // Tamil
  TE: 'te', // Telugu
  MA: 'ma', // Malayalam
} as const;

export const PHILOSOPHIES = {
  ADV: 'adv', // Advaita
  DVA: 'dva', // Dvaita
  VIS: 'vis', // Vishishtadvaita
} as const; 